import { Lightning, Router, Storage } from "@lightningjs/sdk";
import Button from "../../components/button/Button";

import { gridHeight, gridWidth } from "../../services/grid.service";
import { ReportingService, ViewNames } from "../../services/reporting.service";
export default class Exit extends Lightning.Component {
  static _template() {
    return {
      Background: {
        rect: true,
        w: 1920,
        h: 1080,
        color: 0xff000000,
      },
      Title: {
        w: 24 * gridWidth,
        h: 2 * gridHeight,
        y: 6.5 * gridHeight,
        text: {
          text: "Exit?",
          fontFace: "Roboto-Bold",
          fontSize: 54,
          lineHeight: 1 * gridHeight,
          textColor: 0xffffffff,
          textAlign: "center",
          verticalAlign: "top",
          alpha: 1,
          transitions: {
            fontSize: {
              duration: 0.25,
              timingFunction: "linear",
            },
          },
        },
      },
      Description: {
        w: 24 * gridWidth,
        h: 2 * gridHeight,
        y: 9 * gridHeight,
        text: {
          text: "Are you sure you want to close the XITE app?",
          fontFace: "Roboto-Regular",
          fontSize: 36,
          lineHeight: 1 * gridHeight,
          textColor: 0xffffffff,
          textAlign: "center",
          verticalAlign: "top",
          alpha: 1,
          transitions: {
            fontSize: {
              duration: 0.25,
              timingFunction: "linear",
            },
          },
        },
      },
      Buttons: {
        ExitButton: {
          x: 10 * gridWidth,
          y: 12 * gridHeight,
          type: Button,
          width: 4 * gridWidth,
          labelX: 2 * gridWidth,
          label: "Exit the app",
        },
        CancelButton: {
          x: 10 * gridWidth,
          y: 13.5 * gridHeight,
          type: Button,
          width: 4 * gridWidth,
          labelX: 2 * gridWidth,
          label: "Cancel",
        },
      },
    };
  }

  _enable() {
    ReportingService.trackViewChange(Storage.get("sourceViewName"), ViewNames.Exit, false);

    Storage.set("sourceViewName", ViewNames.Exit);
  }

  _getFocused() {
    if (this.focusButtonIndex === undefined) {
      this.focusButtonIndex = 0;
    }

    return this.tag("Buttons").children[this.focusButtonIndex];
  }

  _handleUp() {
    this.focusButtonIndex = 0;
  }

  _handleDown() {
    this.focusButtonIndex = 1;
  }

  async _handleEnter() {
    if (this.focusButtonIndex === 1) {
      Router.back();
    } else {
      await ReportingService.trackExit();
      window.close();
    }
  }
}
